const STORAGETYPE = {
  MAP_DETAILS: "MAP_DETAILS",
  RESTAURANT_DETAILS: "RESTAURANT_DETAILS",
  POINT_OF_CONTACT: "POINT_OF_CONTACT",
  CHAIN_SETTING: "CHAIN_SETTING",
  RESTAURANT_TYPE: "RESTAURANT_TYPE",
  PAYMENT_TYPE: "PAYMENT_TYPE",
  DRESS_CODE: "DRESS_CODE",
  PETS_ALLOWED: "PETS_ALLOWED",
  LOCATED_INSIDE: "LOCATED_INSIDE",
  POINT_OF_SALE: "POINT_OF_SALE",
  HEALTH_AND_SENITATION: "HEALTH_AND_SENITATION",
  PARKING_TYPE: "PARKING_TYPE",
  ACCESSIBILITY: "ACCESSIBILITY",
  OTHER_FEATURES: "OTHER_FEATURES",
  SERVICES_OFFERED: "SERVICES_OFFERED",
  CUISINE_FEATURES: "CUISINE_FEATURES",
  FOOD_TYPE: "FOOD_TYPE",
  CUISINE_OFFERED: "CUISINE_OFFERED",
  BUSINESS_HOURS: "BUSINESS_HOURS",
  KYC_DETAILS: "KYC_DETAILS",
  SUBSCRIPTION_DETAILS: "SUBSCRIPTION_DETAILS",
  FETCH_FLAG: "FETCH_FLAG",
};

export default STORAGETYPE;
